import { Component, OnInit } from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";
import {
  CommonUtility, ServerConstantsService, DataService, SINGLE_ROW_HEADER, ComponentSummary,
  Components, DateUtility, AgGridUtility, AUDIT_BTN, AUDIT_ENTITY_ID, AUDIT_ENTITY_TYPE,
  AUDIT_ENTITY_COLUMN_DEFS, AUDIT_PAGE_TITLE, Task, WpPerson, WpReferral, EmploymentPlan, EmploymentPlanSummary
} from '../shared';

@Component({
  selector: 'app-gridview',
  templateUrl: './gridview.component.html',
  styleUrls: ['./gridview.component.css']
})
export class GridviewComponent implements ICellRendererAngularComp {
  public params: any;
  serverConstants:any;
  constructor(public serverConstantsService: ServerConstantsService) {
    this.serverConstants = serverConstantsService.getConstants();
   }
      agInit(params: any): void {
          this.params = params;
      }
  
      refresh(): boolean {
          return false;
      }
      view(){
          if(this.params.data.doc_type != undefined){
            window.open(this.serverConstants.CITIZEN_API_URL+"/getFile/"+this.params.data.path,"_blank");
          }
          else if(this.params.data.file_location != undefined){
            window.open(this.serverConstants.CITIZEN_API_URL+"/getNotice/"+this.params.data.file_location,"_blank");
          }
      }
}



// WEBPACK FOOTER //
// ./src/app/gridview/gridview.component.ts